export default {"src":"https://cloudflare.edhrec.com/_next/static/media/managp.6ec39a3c.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};